import React, { useState, useEffect } from 'react';
import { configData } from "../config";
import { useLocation } from 'react-router-dom';
import './classes/ForgetPassword.css';
import './classes/UserTab.css';
import Loading from './Loading';

const ForgetPassword = () => {
  const location = useLocation();
  const email = new URLSearchParams(location.search).get('email');
  const [formData, setFormData] = useState({
    email: email
  });
  const app_url = configData.APP_URL;

  const [errors, setErrors] = useState({});
  const[success,setSuccess] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  // const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
  const [userLoggedInId,setUserLoggedInId] = useState({});

  useEffect(() => {
    Promise.all([
    getuserloggedinroles()
    ])
    .then(() => {
      setIsLoading(false);
    })
  },[]);
  async function getuserloggedinroles() {
    try {
      const response = await fetch(
        app_url+'viewprofile/getuserloggedinrolesid',
        {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      const responsedata = await response.json();
      if(responsedata.data) {
        setUserLoggedInId(responsedata.data.user); 
        // setUserLoggedInRoles(responsedata.data.roles);
      } 
    } catch (err) {
          
    } 
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(() => ({
      [name]: value
    }));
  };
  const validate = () => {
    let tempErrors = {};
    if (userLoggedInId === null) {
    if (!formData.email) tempErrors.email = 'Email is required';
    };
    setErrors(tempErrors);
   
    return Object.keys(tempErrors).length === 0;
  }; 
  if (userLoggedInId !== null) {
    formData.email = userLoggedInId.email
  }
  const handleSubmit = async event => {
    event.preventDefault();
    if (validate()) {
      const postData = formData; 
        const response = await fetch(app_url+'forgotpassword/forgot', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
        });
        const data = await response.json();
      
        const resultdata = data.data;
        if(resultdata.msg === "Success") {
          setSuccess(resultdata.msg_details);
        } 
    }
  };

  

  return (
    <>    
    {isLoading ? (
      <Loading />
      ) : (
        <>
    <div className="forget-page-container">
      <div className="forget-page-content">
       {success.length > 0 && (
          <>
           {success.map((item, index) => {
             return <>
            <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {item}
          </div></>
          
        })}  
          </>
        )}
      {(userLoggedInId === null) &&
      <ul class="tabs primarya">
        <li>
          <a href="/user" className="active">
            Log in<span className="element-invisible">(active tab)</span>
          </a>
        </li>
        <li className="active">
          <a href="/user/password">Request new password</a>
        </li>
      </ul>
      }
      <form className="forget-page-form">
        {(userLoggedInId === null) ? (
        <div className="forget-page-form-group">
          <label htmlFor="email" className="forget-page-label">
            E-mail address <span className="forget-page-required">*</span>
          </label>
          <input
            type="text"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            className="forget-page-input"
          />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>
        ) : (
          <p>Password reset instructions will be mailed to <em>{userLoggedInId.email}</em>. You must log out to use the password reset link in the e-mail.</p>
        )}
        <button type="submit" className="forget-page-submit-btn" onClick={handleSubmit}>E-mail new password</button>
      </form>
      <div className="forget-page-message forget-page-warning">
      <img src="/basic/web/images/message-warning.png" alt="warning" />
        <span>
         Please submit your email in above and you will be emailed a link which will log you in. Please check your spam folder if you do not see the email in a few minutes.
        </span>
      </div>
      <div className="forget-page-message forget-page-error">
      <img src="/basic/web/images/message-error.png" alt="error" />
        <p>
       If you do not receive your login email please navigate to the course you would like to register for and submit a new application. You will be able to complete your registration and pay at the end of the process, and at that time your new user account will be created. You may do this even if you have applied in the past.
        </p>
      </div>
    </div>
    </div>
    </>
    )}
    </>
  );
};

export default ForgetPassword;
